import { DateTime } from 'luxon';

export function hasValidReturnReceiptTimestamp(value: unknown): value is string {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value) &&
    DateTime.fromISO(value, { setZone: true }).isValid;
}
